import { routeConstants } from "services/keyConstants";

const baseUrl = `/${routeConstants.WORK_ENVIRONMENT}`;
export const UPDATE_SPECIFIC_DATA = `${baseUrl}/update-specific`;
export const DOWNLOAD = `${baseUrl}/download`;
export const GET_BY_META_INFO = `${baseUrl}/get-by-meta-info`;
export const GET_BY_PROCEDURE_ID = "/procedure/";
export const GET_BY_ID = `${baseUrl}/`;
export const GET_LIST = `${baseUrl}/get-list-dynamic`;
export const UPDATE_AREA = `${baseUrl}/update-area`;
export const GET_FILTERED_DOCS = `${baseUrl}/get-filtered-docs`;
